import { METRICS_DESTINATIONS } from '@cvent/sli-nextjs-metrics';
import { AnalyticsDestinations } from './types';

export const SliEvents = Object.freeze({
  APP_ERROR: {
    id: 'app_error',
    destinations: [METRICS_DESTINATIONS.DATA_DOG]
  },
  CLICK_VIEW_REGISTRATION_SLI: {
    id: 'click_view_registration',
    destinations: [METRICS_DESTINATIONS.DATA_DOG]
  },
  ENGAGEMENT_PANEL_CLICK: {
    id: 'user_engagement_click',
    destinations: [METRICS_DESTINATIONS.DATA_DOG]
  },
  LIVE_POLLING_ERROR_RECOVERY: {
    id: 'live_polling_error_recovery',
    destinations: [METRICS_DESTINATIONS.DATA_DOG]
  },
  LIVE_POLLING_GET_RESULTS: {
    id: 'live_polling_load',
    destinations: [METRICS_DESTINATIONS.DATA_DOG]
  },
  SESSION_ENROLLMENT: {
    id: 'session_enrollment',
    destinations: [METRICS_DESTINATIONS.DATA_DOG]
  },
  TAKE_SESSION_SURVEY: {
    id: 'take_session_survey',
    destinations: [METRICS_DESTINATIONS.DATA_DOG]
  },
  TAKE_SURVEY: {
    id: 'click_take_survey',
    destinations: [METRICS_DESTINATIONS.DATA_DOG]
  },
  // Virtual Room SLIs
  // SLI for join virtual room action
  JOIN_VIRTUAL_ROOM: {
    id: 'join_virtual_room',
    destinations: [METRICS_DESTINATIONS.DATA_DOG]
  },
  // SLI identifier to track the life cycle of the video
  LIVESTREAM_LIFECYCLE: {
    id: 'livestream_lifecycle',
    destinations: [METRICS_DESTINATIONS.DATA_DOG, AnalyticsDestinations.MIXPANEL]
  },
  // SLI identifier to monitor a video player's buffering and QoS events
  LIVESTREAM_BUFFERING: {
    id: 'livestream_buffering_event_monitor',
    destinations: [METRICS_DESTINATIONS.DATA_DOG]
  },
  // Appointment SLIs
  // SLI identifier to monitor latency and non-validation errors during appt creation
  CREATE_APPOINTMENT: {
    id: 'appt_create_form_submit',
    destinations: [METRICS_DESTINATIONS.DATA_DOG]
  },
  // Discussions Text Chat SLIs
  // SLI identifier to monitor latency, availability, and non-validation errors when joining text discussions
  DISCUSSION_JOIN_CHAT: {
    id: 'discussions_join_chat',
    destinations: [METRICS_DESTINATIONS.DATA_DOG]
  },
  // Notifications SLIs
  // SLI for fetching pubnub messages to display the existing notifications
  NOTIFICATION_PUBNUB_FETCH_MESSAGES: {
    id: 'notification_pubnub_fetch_messages',
    destinations: [METRICS_DESTINATIONS.DATA_DOG]
  },
  // SLI for fetching pubnub message action to remove the deleted notifications
  NOTIFICATION_PUBNUB_MESSAGE_ACTIONS: {
    id: 'notification_pubnub_message_actions',
    destinations: [METRICS_DESTINATIONS.DATA_DOG]
  },
  // SLI for subscribing pubnub event listener to receive notifications
  NOTIFICATION_PUBNUB_EVENT_LISTENER: {
    id: 'notification_pubnub_event_listener',
    destinations: [METRICS_DESTINATIONS.DATA_DOG]
  }
});
